module.exports = __webpack_public_path__ + "static/domaindriven-design-25a7f61dd46a6730736e307a428fe518.jpg";